import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ApiResponse, CheckoutResponseDTO, ForteCallbackDTO, PaymentGatewayMerchantSettingDTO, AutoPaymentStatusDTO, SavedPaymentMethodsDTO } from "../model/Gateway-payment";
import { catchError, Observable, tap, throwError } from "rxjs";




@Injectable({ providedIn: 'root' })
export class ForteCheckoutService {
  // private readonly BASE_URL = environment.serviceUrl;
  // private readonly BASE_URL = 'https://wow.atoconn.com/wowcare-school-ms/api'; 
  private readonly BASE_URL = environment.paymentGatewayUrl; 
  private readonly CHECKOUT_URL = `${this.BASE_URL}/v1/payment-gateway-transactions`;

  constructor(private _httpClient: HttpClient) {}

    /*************************************************
     * SERVICES TO GET  RESPONSE
     * @param orgId 
     * @returns 
     ******************************************************/

    // getAllPaymentGatewayMerchantSettings(
    //   page: number = 0,
    //   size: number = 10
    // ): Observable<ApiResponse<PagedResponse<PaymentGatewayMerchantSettingDTO>>> {
    //   const url = `${this.BASE_URL}/v1/payment-gateway-merchant-settings?environment=sachin&page=${page}&size=${size}`;
    
    //   return this._httpClient
    //     .get<ApiResponse<PagedResponse<PaymentGatewayMerchantSettingDTO>>>(url)
    //     .pipe(
    //       tap((response) => {
    //         if (!response.success) {
    //           console.warn('Failed to fetch merchant settings:', response.message);
    //         }
    //       }),
    //       catchError((error) => {
    //         console.error('Error fetching merchant settings:', error);
    //         const errorResponse: ApiResponse<PagedResponse<PaymentGatewayMerchantSettingDTO>> = error?.error || {
    //           success: false,
    //           message: error.message || 'Merchant settings fetch failed',
    //           data: {
    //             content: [],
    //             totalElements: 0,
    //             totalPages: 0,
    //             number: page,
    //             size: size
    //           },
    //           timestamp: new Date()
    //         };
    //         return throwError(() => errorResponse);
    //       })
    //     );
    // }
    
  

    createPaymentGatewayMerchantSetting(
      payload: PaymentGatewayMerchantSettingDTO
    ): Observable<ApiResponse<PaymentGatewayMerchantSettingDTO>> {
      const url = `${this.BASE_URL}/v1/payment-gateway-merchant-settings`; 
      return this._httpClient
        .post<ApiResponse<PaymentGatewayMerchantSettingDTO>>(url, payload)
        .pipe(
          tap((response) => {
            if (!response.success) {
              console.warn('Failed to create payment gateway settings:', response.message);
            }
          }),
          catchError((error) => {
            console.error('Error creating payment gateway settings:', error);
            const errorResponse: ApiResponse<PaymentGatewayMerchantSettingDTO> = error?.error || {
              success: false,
              message: error.message || 'Payment gateway setting creation failed',
              data: null,
              timestamp: new Date().toISOString()
            };
            return throwError(() => errorResponse);
          })
        );
    }
  

  /*************************************************
   * SERVICE TO POST CREATE SIGNATURE and SEND CALLBACK DATA
   * @param checkoutData 
   * @returns 
   ******************************************************/
  getCheckoutSignature(payload: any): Observable<ApiResponse<CheckoutResponseDTO>> {
    return this._httpClient
      .post<ApiResponse<CheckoutResponseDTO>>(this.CHECKOUT_URL, payload)
      .pipe(
        tap((response) => {
          if (!response.success) {
            console.warn('Checkout signature generation failed:', response.message);
          }
        }),
        catchError((error) => {
          console.error('Error generating checkout signature:', error);
          const errorResponse: ApiResponse<CheckoutResponseDTO> = error?.error || {
            success: false,
            message: error.message || 'Checkout signature generation failed',
            data: null,
            timestamp: new Date().toISOString()
          };
          return throwError(() => errorResponse);
        })
      );
  }
  
  sendForteCallbackResponse(code: string, payload: ForteCallbackDTO): Observable<ApiResponse<any>> {
    const url = `${this.CHECKOUT_URL}/${code}`;
    return this._httpClient
      .patch<ApiResponse<any>>(url, payload)
      .pipe(
        tap((response) => {
          if (!response.success) {
            console.warn('Forte callback response failed:', response.message);
          }
        }),
        catchError((error) => {
          console.error('Error sending Forte callback response:', error);
          const errorResponse: ApiResponse<any> = error?.error || {
            success: false,
            message: error.message || 'Forte callback response failed',
            data: null,
            timestamp: new Date().toISOString()
          };
          return throwError(() => errorResponse);
        })
      );
  }

  refundIdChanges(code: string, payload: any): Observable<ApiResponse<any>> {
    const url = `${this.CHECKOUT_URL}/${code}`;
    return this._httpClient
      .patch<ApiResponse<any>>(url, payload)
      .pipe(
        tap((response) => {
          if (!response.success) {
            console.warn('Forte callback response failed:', response.message);
          }
        }),
        catchError((error) => {
          console.error('Error sending Forte callback response:', error);
          const errorResponse: ApiResponse<any> = error?.error || {
            success: false,
            message: error.message || 'Forte callback response failed',
            data: null,
            timestamp: new Date().toISOString()
          };
          return throwError(() => errorResponse);
        })
      );
  }
  
  
  /**
   * Create payment token for auto-payment
   */
  createPaymentToken(schoolId: string, isEcheck: boolean, payload: {
    oneTimeToken: string;
    firstName: string;
    lastName: string;
    guardianId: number;
    payMethod: string;
    studentIds: number[];
    companyName: string;  
  }): Observable<ApiResponse<any>> {
    const url = `${environment.serviceUrl}/tokens/create/${schoolId}?isEcheck=${isEcheck}`;
    return this._httpClient
      .post<ApiResponse<any>>(url, payload)
      .pipe(
        tap((response) => {
          if (!response.success) {
            console.warn('Token creation failed:', response.message);
          }
        }),
        catchError((error) => {
          console.error('Error creating payment token:', error);
          const errorResponse: ApiResponse<any> = error?.error || {
            success: false,
            message: error.message || 'Token creation failed',
            data: null,
            timestamp: new Date().toISOString()
          };
          return throwError(() => errorResponse);
        })
      );
  }

  /**
   * Update payment token for auto-payment
   */
  updatePaymentToken(schoolId: string, isEcheck: boolean, payload: {
      oneTimeToken: string;
      firstName: string;
      lastName: string;
      guardianId: number;
      payMethod: string;
      studentIds: number[];
      companyName: string;  
  }): Observable<ApiResponse<any>> {
      const url = `${environment.serviceUrl}/tokens/update/${schoolId}?isEcheck=${isEcheck}`;
      return this._httpClient
          .patch<ApiResponse<any>>(url, payload)
          .pipe(
              tap((response) => {
                  if (!response.success) {
                      console.warn('Token update failed:', response.message);
                  }
              }),
              catchError((error) => {
                  console.error('Error updating payment token:', error);
                  const errorResponse: ApiResponse<any> = error?.error || {
                      success: false,
                      message: error.message || 'Token update failed',
                      data: null,
                      timestamp: new Date().toISOString()
                  };
                  return throwError(() => errorResponse);
              })
          );
  }

    /**
   * Check if auto payment is enabled for a parent
   */
    checkAutoPaymentStatus(schoolId: string, guardianId: number): Observable<ApiResponse<AutoPaymentStatusDTO>> {
        const url = `${environment.serviceUrl}/tokens/check/autopay-status`;
        const params = {
            schoolId: schoolId,
            guardianId: guardianId.toString()
        };
        
        return this._httpClient
            .get<ApiResponse<AutoPaymentStatusDTO>>(url, { params })
            .pipe(
                tap((response) => {
                    if (!response.success) {
                        console.warn('Auto payment status check failed:', response.message);
                    }
                }),
                catchError((error) => {
                    console.error('Error checking auto payment status:', error);
                    const errorResponse: ApiResponse<AutoPaymentStatusDTO> = error?.error || {
                        success: false,
                        message: error.message || 'Auto payment status check failed',
                        data: { status: 'DISABLED' },
                        timestamp: new Date().toISOString()
                    };
                    return throwError(() => errorResponse);
                })
            );
    }
  /**
   * Disable auto payment for a parent
  */
  disableAutoPayment(schoolId: string, guardianId: number): Observable<ApiResponse<any>> {
      const url = `${environment.serviceUrl}/tokens/disable`;
      const params = {
          schoolId: schoolId,
          guardianId: guardianId.toString()
      };
      
      return this._httpClient
          .post<ApiResponse<any>>(url, null, { params })
          .pipe(
              tap((response) => {
                  if (!response.success) {
                      console.warn('Auto payment disable failed:', response.message);
                  }
              }),
              catchError((error) => {
                  console.error('Error disabling auto payment:', error);
                  const errorResponse: ApiResponse<any> = error?.error || {
                      success: false,
                      message: error.message || 'Auto payment disable failed',
                      data: null,
                      timestamp: new Date().toISOString()
                  };
                  return throwError(() => errorResponse);
              })
          );
  }

  /**
   * Enable auto payment for a parent
   */
  enableAutoPayment(schoolId: string, guardianId: number): Observable<ApiResponse<any>> {
      const url = `${environment.serviceUrl}/tokens/enable`;
      const params = {
          schoolId: schoolId,
          guardianId: guardianId.toString()
      };

      return this._httpClient
          .post<ApiResponse<any>>(url, null, { params })
          .pipe(
              tap((response) => {
                  if (!response.success) {
                      console.warn('Auto payment enable failed:', response.message);
                  }
              }),
              catchError((error) => {
                  console.error('Error enabling auto payment:', error);
                  const errorResponse: ApiResponse<any> = error?.error || {
                      success: false,
                      message: error.message || 'Auto payment enable failed',
                      data: null,
                      timestamp: new Date().toISOString()
                  };
                  return throwError(() => errorResponse);
              })
          );
    }

  /**
   * Get Forte API login ID for a school (for parent users only)
   * Response data is a string directly (e.g., "FC566FFG8U")
   */
  getForteApiLoginId(schoolCode: string): Observable<ApiResponse<string>> {
      const url = `${environment.serviceUrl}/v1/school-forte-api-login-id/${schoolCode}`;
      
      return this._httpClient
          .get<ApiResponse<string>>(url)
          .pipe(
              tap((response) => {
                  if (!response.success) {
                      console.warn('Failed to fetch Forte API login ID:', response.message);
                  }
              }),
              catchError((error) => {
                  console.error('Error fetching Forte API login ID:', error);
                  const errorResponse: ApiResponse<string> = error?.error || {
                      success: false,
                      message: error.message || 'Forte API login ID fetch failed',
                      data: null,
                      timestamp: new Date().toISOString()
                  };
                  return throwError(() => errorResponse);
              })
          );
  }

  /**
   * Get saved payment methods for a guardian
   * @param guardianId - The guardian ID
   * @param schoolId - The school ID
   * @returns Observable with saved card and echeck data
   */
  getSavedPaymentMethods(guardianId: number, schoolId: string): Observable<SavedPaymentMethodsDTO> {
      const url = `${environment.serviceUrl}/tokens/paymethods/guardian/${guardianId}/school_code/${schoolId}`;
      
      return this._httpClient
          .get<SavedPaymentMethodsDTO>(url)
          .pipe(
              tap((response) => {
                  // Response is directly the SavedPaymentMethodsDTO object
              }),
              catchError((error) => {
                  console.error('Error fetching saved payment methods:', error);
                  // Return empty payment methods on error
                  const emptyResponse: SavedPaymentMethodsDTO = {
                      card: null,
                      echeck: null,
                      default: false
                  };
                  return throwError(() => emptyResponse);
              })
          );
  }

  /**
   * Update payment method (card or echeck) - Unified API
   * @param guardianId - The guardian ID
   * @param schoolId - The school ID  
   * @param payload - Payment method update payload
   * @returns Observable with API response
   */
  updatePaymentMethod(guardianId: number, schoolId: string, payload: {
      label: string;
      card?: {
          nameOnCard: string;
          expireMonth: number;
          expireYear: number;
      };
      echeck?: {
          accountHolder: string;
          routingNumber: string;
          accountType: string;
          itemDescription?: string;
      };
  }): Observable<ApiResponse<any>> {
      const url = `${environment.serviceUrl}/tokens/paymethods/guardian/${guardianId}/school_code/${schoolId}`;
      
      return this._httpClient
          .put<ApiResponse<any>>(url, payload)
          .pipe(
              tap((response) => {
                  if (!response.success) {
                      console.warn('Payment method update failed:', response.message);
                  }
              }),
              catchError((error) => {
                  console.error('Error updating payment method:', error);
                  const errorResponse: ApiResponse<any> = error?.error || {
                      success: false,
                      message: error.message || 'Payment method update failed',
                      data: null,
                      timestamp: new Date().toISOString()
                  };
                  return throwError(() => errorResponse);
              })
          );
  }

}
